<template>
  <v-snackbar
    v-model="snackbar"
  >
    {{ error }}

    <template v-slot:action="{ attrs }">
      <v-btn
        color="secondary"
        text
        v-bind="attrs"
        multi-line
        timeout="3141592"
        @click="close"
      >
        TANCA
      </v-btn>
    </template>
  </v-snackbar>
</template>


<script>
 import { mapMutations, mapState } from 'vuex';

 export default {
   name: 'App',

   components: {
   },

   data: () => ({
     snackbar: false,
   }),

   computed: {
     ...mapState(['error']),
   },

   methods: {
     ...mapMutations(['RESET_ERROR']),

     close() {
       this.RESET_ERROR();
     }
   },

   watch: {
     error(msg) {
       this.snackbar = !!msg;
     },
   },
 };
</script>

